function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import { MediaContext } from 'react-media-query-hoc';
import isEmpty from 'lodash/isEmpty';
import { BodySection, Button, FullWidth } from '@domain-group/fe-co-allhomes-design-system';
import { BTR_MORE_RESULTS_EXPANDED_LOCALITIES, BTR_MORE_RESULTS_MAX_ADDITIONAL_LISTINGS } from './btr-more-config';
import * as styles from './listings-list.style';
import { WrappedListingCard } from '../wrapped-listing-card';
import { jsx as ___EmotionJSX } from "@emotion/core";
var getHeading = isBTRExclusiveResult => {
  if (isBTRExclusiveResult) {
    return 'Results from outside your search';
  }
  return 'Consider these other rentals';
};
var getSubHeading = (isBTRExclusiveResult, totalHits, primarySearchResult) => {
  var totalHitsDelta = totalHits - primarySearchResult.totalHits;
  if (isBTRExclusiveResult) {
    if (totalHitsDelta > 1) {
      return 'There are additional Build-to-Rent properties outside your search area.';
    }
    if (totalHitsDelta === 1) {
      return 'There is an additional Build-to-Rent property outside your search area.';
    }
    return 'There may be additional Build-to-Rent properties outside your search area.';
  }
  var suffix = 'available for rent. Expand your search filters to view more available rental properties.';
  if (totalHitsDelta > 1) {
    return "There are additional ".concat(totalHitsDelta, " properties ").concat(suffix);
  }
  if (totalHitsDelta === 1) {
    return "There is an additional property ".concat(suffix);
  }
  return "There may be additional properties ".concat(suffix);
};
var ListingsList = _ref => {
  var _ref$searchResults = _ref.searchResults,
    searchResults = _ref$searchResults === void 0 ? [] : _ref$searchResults,
    _ref$totalHits = _ref.totalHits,
    totalHits = _ref$totalHits === void 0 ? 0 : _ref$totalHits,
    onAddToWatchlist = _ref.onAddToWatchlist,
    onViewAll = _ref.onViewAll,
    primarySearchResult = _ref.primarySearchResult,
    isBTRExclusiveResult = _ref.isBTRExclusiveResult;
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile;
  var listingList = searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(result => ___EmotionJSX("div", {
    css: styles.row,
    key: "listing-".concat(result.listing.id)
  }, ___EmotionJSX(WrappedListingCard, _extends({
    appearance: mobile ? 'vertical' : 'horizontal',
    css: styles.item,
    onAddToWatchlist: onAddToWatchlist
  }, result))));
  if (isEmpty(searchResults)) {
    return ___EmotionJSX(React.Fragment, null);
  }
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(FullWidth, {
    css: styles.listingsListContainer
  }, ___EmotionJSX(BodySection, {
    css: styles.items
  }, ___EmotionJSX("h2", {
    css: styles.resultsHeading
  }, getHeading(isBTRExclusiveResult)), ___EmotionJSX("p", {
    css: styles.resultSubheading
  }, getSubHeading(isBTRExclusiveResult, totalHits, primarySearchResult)), listingList, totalHits > BTR_MORE_RESULTS_MAX_ADDITIONAL_LISTINGS && ___EmotionJSX(Button, {
    onClick: () => {
      onViewAll(BTR_MORE_RESULTS_EXPANDED_LOCALITIES);
    }
  }, totalHits > 1 ? "View all ".concat(totalHits, " properties") : 'View all'))));
};
export { ListingsList };